(function () {
  'use strict';

  angular
    .module('usuarios')
    .service('UsuariosService', Restangular => Restangular.service('auth/usuarios'))
    .service('UsuariosServiceV2', Restangular => Restangular.service('auth/v2/usuarios'))
    .service('PaisService', Restangular => Restangular.service('auth/paises'));
}());
